import Script from "next/script";
import { useSelector } from "react-redux";
import { getAcceptAll } from "../../reducers/CookiePreferenceReducer";

const TrackingScripts = () => {
  const facebookPixelCode = "938117079582809";
  const isCookieTrackingAccepted = useSelector(getAcceptAll);

  return (
    <>
      <Script
        id="fontawesome-js"
        strategy="afterInteractive"
        src="https://kit.fontawesome.com/0259555302.js"
      />
      {isCookieTrackingAccepted && (
        <Script
          id="facebook-js"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
            !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
            n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.defer=true;
            t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
            document,'script','https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', ${facebookPixelCode});
            fbq('track', 'PageView');
          `,
          }}
        ></Script>
      )}
    </>
  );
};

export default TrackingScripts;
